// tailwind.extension.ts

// Do not edit directly
// Generated on Fri, 05 Jan 2024 14:25:03 GMT

export const users_app_tailwind_config = {
  spacing: {
    "cta-button-1-height": "2rem",
    "dynamic-mobile-cta-button-1-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-1-height": "2.962962962962963vh",
    "cta-button-1-width": "5.875rem",
    "dynamic-mobile-cta-button-1-width": "26.11111111111111vw",
    "dynamic-desktop-cta-button-1-width": "4.895833333333333vw",
    "cta-button-2-height": "2rem",
    "dynamic-mobile-cta-button-2-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-2-height": "2.962962962962963vh",
    "cta-button-2-width": "5.875rem",
    "dynamic-mobile-cta-button-2-width": "26.11111111111111vw",
    "dynamic-desktop-cta-button-2-width": "4.895833333333333vw",
    "cta-button-3-height": "2.5rem",
    "dynamic-mobile-cta-button-3-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-3-height": "3.7037037037037037vh",
    "cta-button-3-width": "15.75rem",
    "dynamic-mobile-cta-button-3-width": "70vw",
    "dynamic-desktop-cta-button-3-width": "13.125vw",
    "cta-dropdown-1-height": "7.25rem",
    "dynamic-mobile-cta-dropdown-1-height": "16.292134831460675vh",
    "dynamic-desktop-cta-dropdown-1-height": "10.74074074074074vh",
    "cta-dropdown-1-width": "15.625rem",
    "dynamic-mobile-cta-dropdown-1-width": "69.44444444444444vw",
    "dynamic-desktop-cta-dropdown-1-width": "13.020833333333334vw",
    "cta-dropdown-2-height": "1.625rem",
    "dynamic-mobile-cta-dropdown-2-height": "3.651685393258427vh",
    "dynamic-desktop-cta-dropdown-2-height": "2.4074074074074074vh",
    "cta-dropdown-2-width": "15.625rem",
    "dynamic-mobile-cta-dropdown-2-width": "69.44444444444444vw",
    "dynamic-desktop-cta-dropdown-2-width": "13.020833333333334vw",
    "frame-entryfield-1-height": "2.25rem",
    "dynamic-mobile-frame-entryfield-1-height": "5.056179775280899vh",
    "dynamic-desktop-frame-entryfield-1-height": "3.3333333333333335vh",
    "frame-entryfield-1-width": "15.625rem",
    "dynamic-mobile-frame-entryfield-1-width": "69.44444444444444vw",
    "dynamic-desktop-frame-entryfield-1-width": "13.020833333333334vw",
    "frame-entryfield-2-height": "2.25rem",
    "dynamic-mobile-frame-entryfield-2-height": "5.056179775280899vh",
    "dynamic-desktop-frame-entryfield-2-height": "3.3333333333333335vh",
    "frame-entryfield-2-width": "2.25rem",
    "dynamic-mobile-frame-entryfield-2-width": "10vw",
    "dynamic-desktop-frame-entryfield-2-width": "1.875vw",
    "frame-entryfield-3-height": "2.25rem",
    "dynamic-mobile-frame-entryfield-3-height": "5.056179775280899vh",
    "dynamic-desktop-frame-entryfield-3-height": "3.3333333333333335vh",
    "frame-entryfield-3-width": "15.625rem",
    "dynamic-mobile-frame-entryfield-3-width": "69.44444444444444vw",
    "dynamic-desktop-frame-entryfield-3-width": "13.020833333333334vw",
    "frame-snackbar-1-height": "2rem",
    "dynamic-mobile-frame-snackbar-1-height": "4.49438202247191vh",
    "dynamic-desktop-frame-snackbar-1-height": "2.962962962962963vh",
    "frame-snackbar-1-width": "22.5rem",
    "dynamic-mobile-frame-snackbar-1-width": "100vw",
    "dynamic-desktop-frame-snackbar-1-width": "18.75vw",
    "frame-snackbar-2-height": "2rem",
    "dynamic-mobile-frame-snackbar-2-height": "4.49438202247191vh",
    "dynamic-desktop-frame-snackbar-2-height": "2.962962962962963vh",
    "frame-snackbar-2-width": "22.5rem",
    "dynamic-mobile-frame-snackbar-2-width": "100vw",
    "dynamic-desktop-frame-snackbar-2-width": "18.75vw",
    "frame-snackbar-3-height": "2rem",
    "dynamic-mobile-frame-snackbar-3-height": "4.49438202247191vh",
    "dynamic-desktop-frame-snackbar-3-height": "2.962962962962963vh",
    "frame-snackbar-3-width": "22.5rem",
    "dynamic-mobile-frame-snackbar-3-width": "100vw",
    "dynamic-desktop-frame-snackbar-3-width": "18.75vw",
    "frame-no internet-height": "2rem",
    "dynamic-mobile-frame-no internet-height": "4.49438202247191vh",
    "dynamic-desktop-frame-no internet-height": "2.962962962962963vh",
    "frame-no internet-width": "22.5rem",
    "dynamic-mobile-frame-no internet-width": "100vw",
    "dynamic-desktop-frame-no internet-width": "18.75vw",
  },
  borderRadius: {
    "cta-button-1-borderRadius": "0.375rem",
    "cta-button-2-borderRadius": "0.375rem",
    "cta-button-3-borderRadius": "0.5rem",
    "cta-dropdown-1-borderRadius": "0.375rem",
    "cta-dropdown-2-borderRadius": "0rem",
    "frame-entryfield-1-borderRadius": "0.375rem",
    "frame-entryfield-2-borderRadius": "0.375rem",
    "frame-entryfield-3-borderRadius": "0.375rem",
  },
  colors: {
    "cta-button-1-fill": "#7F95FF",
    "cta-button-2-fill": "#999999",
    "cta-button-3-fill": "#202020",
    "cta-typo-1-fill": "#F2F2F2",
    "cta-dropdown-1-borderColor": "#262D4C",
    "cta-dropdown-1-fill": "#202020",
    "cta-dropdown-2-fill": "#333333",
    "frame-entryfield-1-borderColor": "#262D4C",
    "frame-entryfield-1-fill": "#202020",
    "frame-entryfield-2-borderColor": "#262D4C",
    "frame-entryfield-2-fill": "#202020",
    "frame-entryfield-3-borderColor": "#262D4C",
    "frame-entryfield-3-fill": "#202020",
    "frame-snackbar-1-fill": "#5DC780",
    "frame-snackbar-2-fill": "#D45858",
    "frame-snackbar-3-fill": "#EEAB5E",
    "frame-no internet-fill": "#D45858",
    "primary-30": "#262D4C",
    "primary-100": "#7F95FF",
    "bg-100": "#000000",
    "on-bg-25": "#202020",
    "on-bg-60": "#999999",
    "on-bg-70": "#B2B2B2",
    "on-bg-80": "#CCCCCC",
    "on-bg-90": "#E5E5E5",
    "on-bg-95": "#F2F2F2",
    "on-bg-100": "#FFFFFF",
    "error-100": "#D45858",
  },
  fontFamily: {
    "cta-typo-1-fontFamilies": "Circular Std, sans-serif",
    "title-lg_1-fontFamily": "Gilroy, sans-serif",
    "title-lg2_1-fontFamily": "Gilroy, sans-serif",
    "title-md_1-fontFamily": "Circular Std, sans-serif",
    "title-md_2-fontFamily": "Circular Std, sans-serif",
    "title-md2_1-fontFamily": "Circular Std, sans-serif",
    "title-md2_2-fontFamily": "Circular Std, sans-serif",
    "body-md_1-fontFamily": "Circular Std, sans-serif",
    "body-md2_1-fontFamily": "Circular Std, sans-serif",
    "body-md3_1-fontFamily": "Circular Std, sans-serif",
    "body-md3_2-fontFamily": "Circular Std, sans-serif",
    "body-md3_3-fontFamily": "Circular Std, sans-serif",
  },
  fontWeight: {
    "cta-typo-1-fontWeights": 500,
    "title-lg_1-fontWeight": "ExtraBold",
    "title-lg2_1-fontWeight": "ExtraBold",
    "title-md_1-fontWeight": 300,
    "title-md_2-fontWeight": 500,
    "title-md2_1-fontWeight": 700,
    "title-md2_2-fontWeight": 300,
    "body-md_1-fontWeight": 500,
    "body-md2_1-fontWeight": 400,
    "body-md3_1-fontWeight": 500,
    "body-md3_2-fontWeight": 700,
    "body-md3_3-fontWeight": 700,
  },
  fontSize: {
    "cta-typo-1-fontSizes": "0.625rem",
    "title-lg_1-fontSize": "1rem",
    "title-lg2_1-fontSize": "2rem",
    "title-md_1-fontSize": "0.75rem",
    "title-md_2-fontSize": "0.75rem",
    "title-md2_1-fontSize": "0.875rem",
    "title-md2_2-fontSize": "0.875rem",
    "body-md_1-fontSize": "0.75rem",
    "body-md2_1-fontSize": "0.8125rem",
    "body-md3_1-fontSize": "0.875rem",
    "body-md3_2-fontSize": "0.875rem",
    "body-md3_3-fontSize": "0.875rem",
  },
  lineHeight: {
    "cta-typo-1-lineHeights": "inherit",
    "title-lg_1-lineHeight": "inherit",
    "title-lg2_1-lineHeight": "inherit",
    "title-md_1-lineHeight": "inherit",
    "title-md_2-lineHeight": "inherit",
    "title-md2_1-lineHeight": "inherit",
    "title-md2_2-lineHeight": "inherit",
    "body-md_1-lineHeight": "inherit",
    "body-md2_1-lineHeight": "inherit",
    "body-md3_1-lineHeight": "inherit",
    "body-md3_2-lineHeight": "inherit",
    "body-md3_3-lineHeight": "inherit",
  },
  letterSpacing: {
    "cta-typo-1-letterSpacing": "0.03rem",
    "title-lg_1-letterSpacing": "0rem",
    "title-lg2_1-letterSpacing": "0rem",
    "title-md_1-letterSpacing": "0rem",
    "title-md_2-letterSpacing": "0.03rem",
    "title-md2_1-letterSpacing": "0rem",
    "title-md2_2-letterSpacing": "0rem",
    "body-md_1-letterSpacing": "0rem",
    "body-md2_1-letterSpacing": "0rem",
    "body-md3_1-letterSpacing": "0rem",
    "body-md3_2-letterSpacing": "0.03rem",
    "body-md3_3-letterSpacing": "0rem",
  },
  borderWidth: {
    "cta-dropdown-1-borderWidth": "0.01875rem",
    "cta-dropdown-2-borderWidth": "0.01875rem",
    "frame-entryfield-1-borderWidth": "0.01875rem",
    "frame-entryfield-2-borderWidth": "0.01875rem",
    "frame-entryfield-3-borderWidth": "0.01875rem",
  },
};

export const users_app_plugin_components = {
  ".typography-cta-typo-1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.625rem",
    lineHeight: "inherit",
    letterSpacing: "0.03rem",
    textDecoration: "underline",
  },
  ".typography-title-lg_1": {
    fontFamily: "Gilroy, sans-serif",
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    fontWeight: "ExtraBold",
  },
  ".typography-title-lg2_1": {
    fontFamily: "Gilroy, sans-serif",
    lineHeight: "inherit",
    fontSize: "2rem",
    letterSpacing: "0rem",
    fontWeight: "ExtraBold",
  },
  ".typography-title-md_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
  },
  ".typography-title-md_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.03rem",
    textDecoration: "none",
  },
  ".typography-title-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
  },
  ".typography-title-md2_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.8125rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md3_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
  },
  ".typography-body-md3_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0.03rem",
  },
  ".typography-body-md3_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".composition-cta-button-1": {
    height: "2rem",
    width: "5.875rem",
    borderRadius: "0.375rem",
    backgroundColor: "#7F95FF",
  },
  ".composition-cta-button-2": {
    height: "2rem",
    width: "5.875rem",
    borderRadius: "0.375rem",
    backgroundColor: "#999999",
  },
  ".composition-cta-button-3": {
    height: "2.5rem",
    width: "15.75rem",
    backgroundColor: "#202020",
    borderRadius: "0.5rem",
  },
  ".composition-cta-dropdown-1": {
    height: "7.25rem",
    width: "15.625rem",
    borderRadius: "0.375rem",
    borderColor: "#262D4C",
    backgroundColor: "#202020",
  },
  ".composition-cta-dropdown-2": {
    height: "1.625rem",
    width: "15.625rem",
    borderRadius: "0rem",
    backgroundColor: "#333333",
  },
  ".composition-frame-entryfield-1": {
    height: "2.25rem",
    width: "15.625rem",
    borderRadius: "0.375rem",
    borderColor: "#262D4C",
    backgroundColor: "#202020",
  },
  ".composition-frame-entryfield-2": {
    height: "2.25rem",
    width: "2.25rem",
    borderRadius: "0.375rem",
    borderColor: "#262D4C",
    backgroundColor: "#202020",
  },
  ".composition-frame-entryfield-3": {
    height: "2.25rem",
    width: "15.625rem",
    borderRadius: "0.375rem",
    borderColor: "#262D4C",
    backgroundColor: "#202020",
  },
  ".composition-frame-snackbar-1": {
    height: "2rem",
    width: "22.5rem",
    backgroundColor: "#5DC780",
  },
  ".composition-frame-snackbar-2": {
    height: "2rem",
    width: "22.5rem",
    backgroundColor: "#D45858",
  },
  ".composition-frame-snackbar-3": {
    height: "2rem",
    width: "22.5rem",
    backgroundColor: "#EEAB5E",
  },
  ".composition-frame-no internet": {
    height: "2rem",
    width: "22.5rem",
    backgroundColor: "#D45858",
  },
};
